import cn from "classnames"

import { Flex, Text } from "@/atoms"
import { useTranslation } from "@/hooks/useTranslation"
import { Kai, KaiSecondary } from "@/icons"
import { Heading } from "@/molecules/Heading"
import { KaiButton } from "@/molecules/KaiButton"

import styles from "./NextStepsTabAdr.module.scss"

export const KaiStep = () => {
  const { t } = useTranslation("translation", {
    keyPrefix: "triage.adr.tabs.nextSteps.kai"
  })

  return (
    <div className={styles.wrapper}>
      <Kai className={cn(styles.icon, styles.iconKai)} />
      <Flex vertical gap={8} className={styles.kai}>
        <Heading level={4} title={t("title")} />
        <Flex justify="space-between" align="center" className={styles.card}>
          <Flex gap={12} align="center">
            <KaiSecondary className={styles.iconAskKai} />
            <Text>{t("description")}</Text>
          </Flex>
          <KaiButton disabled />
        </Flex>
      </Flex>
    </div>
  )
}
